export default "__VITE_ASSET__X7nGRpNn__"